import { Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { DetailedCourse, Learning } from "../../../Constant";
import CourseFilter from "../LearningList/CourseFilter";
import BlogSingle from "./BlogSingle";

const DetailedCourseContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={DetailedCourse} parent={Learning} title={DetailedCourse} />
      <Container fluid>
        <Row>
          <Col xl="9" className="xl-60 order-xl-0 order-1 box-col-8">
            <BlogSingle />
          </Col>
          <Col xl="3" className="xl-40 box-col-4e learning-filter">
            <CourseFilter />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default DetailedCourseContainer;
